import { Language } from 'types/language'
import dayjs from 'dayjs'
import { AvailabilityOverride } from './types'

export const DAY_OF_WEEK = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
} as const

export const AVAILABILITY_OVERRIDES: AvailabilityOverride[] = [
  // Summer 2025 override
  {
    start: dayjs('2025-07-01').startOf('month'),
    end: dayjs('2025-08-01').endOf('month'),
    dayOfWeek: [DAY_OF_WEEK.thursday, DAY_OF_WEEK.friday], // Thursday and Friday
    message: {
      [Language.DUTCH]: 'We zijn vandaag bereikbaar tot 13:00',
      [Language.FRENCH]: "Aujourd'hui, nous sommes joignables jusqu'à 13h"
    }
  }
]
